var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center container-geral-lancar-pagamento"},[_c('div',{staticClass:"container-components-lancar-pagamento",attrs:{"role":"tablist"}},[_c('BillDetails')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }